import PropertyPrescreeningSettings from "./PropertyPrescreeningSettings";

export default PropertyPrescreeningSettings;
